export default "__VITE_ASSET__84b8419a__"